// global
import global from "../../assets/traslations/en/global.json";

// auth
import forgot_pass from "../../assets/traslations/en/auth/forgot_pass.json";
import login from "../../assets/traslations/en/auth/login.json";
import profile from "../../assets/traslations/en/auth/profile.json";
import register from "../../assets/traslations/en/auth/register.json";
import reset_pass from "../../assets/traslations/en/auth/reset_pass.json";
import validate_email from "../../assets/traslations/en/auth/validate_email.json";

// master
import contact from "../../assets/traslations/en/master/contact.json";
import client from "../../assets/traslations/en/master/client.json";
import delivery from "../../assets/traslations/en/master/delivery.json";
import driver from "../../assets/traslations/en/master/driver.json";
import transport from "../../assets/traslations/en/master/transport.json";
import operators from "../../assets/traslations/en/master/operators.json";
import zone from "../../assets/traslations/en/master/zone.json";

// reports
import invoices from "../../assets/traslations/en/reports/invoices.json";
import orders from "../../assets/traslations/en/reports/orders.json";
import routeCost from "../../assets/traslations/en/reports/routeCost.json";
import routes from "../../assets/traslations/en/reports/routes.json";

// transactions
import order from "../../assets/traslations/en/transactions/order.json";
import quote from "../../assets/traslations/en/transactions/quote.json";
import route from "../../assets/traslations/en/transactions/route.json";
import invoice from "../../assets/traslations/en/transactions/invoice.json";

// config
import cost from "../../assets/traslations/en/config/cost.json";
import transportBrand from "../../assets/traslations/en/config/transportBrand.json";
import transportSupplier from "../../assets/traslations/en/config/transportSupplier.json";


const en = {
    // global
    global,

    // auth
    forgot_pass,
    login,
    profile,
    register,
    reset_pass,
    validate_email,

    // master
    contact,
    client,
    delivery,
    driver,
    transport,
    operators,
    zone,

    // reports
    invoices,
    orders,
    routeCost,
    routes,

    // transactions
    order,
    quote,
    route,
    invoice,

    // config
    cost,
    transportBrand,
    transportSupplier,
}

export default en;
